// Configuration for each operational board
export const BOARD_CONFIG = {
  // TASKS
  5088243937: {
    name: "TASKS",
    propertyColumnId: "board_relation_mky2d8h0",
    dueDateColumnId: "date4",
    statusColumnId: "status",
    color: "#fa1b1b", // Red
  },
  // WEEKLY CHECKS
  5088246586: {
    name: "Weekly Checks",
    propertyColumnId: "board_relation_mky2zggq",
    dueDateColumnId: "date4",
    statusColumnId: "status",
    typeColumnId: "color_mky2n4xa", // Type column (Weekly Check / Monthly Check)
    color: "#00d9ff", // Strong turquoise
  },
  // MAINTENANCE
  5088283223: {
    name: "Maintenance",
    propertyColumnId: "board_relation_mky36t8w",
    dueDateColumnId: "date_mky3mjzh",
    statusColumnId: "color_mky3jres",
    color: "#ffcb00", // Yellow
  },
  // METER READINGS
  5088238378: {
    name: "Meter Readings",
    propertyColumnId: "board_relation_mky2g2wt",
    // Window for task: start & end
    dueDateColumnId: "date_mky9dgw1", // Due Date
    startDateColumnId: "date4", // Window Start
    endDateColumnId: "date_mky3yhva", // Window End
    statusColumnId: "status",
    color: "#ff932e", // Strong orange
  },
  // REPORTS
  5088279319: {
    name: "Reports",
    propertyColumnId: "board_relation_mky3yhcf",
    dueDateColumnId: "date4",
    statusColumnId: "status",
    color: "#a25ddc", // Purple
  },
  // CLEANING CHECKS
  5088644309: {
    name: "Cleaning Checks",
    propertyColumnId: "lookup_mkybsny5", // Property lookup column (mirror, returns null)
    bookingsRelationColumnId: "board_relation_mkybf63a", // Board relation to BOOKINGS board
    bookingsPropertyColumnId: "board_relation_mkyabpt4", // Property column in BOOKINGS board (links to Properties)
    checkInDateColumnId: "date_mkynw1pn", // Check-in Date
    checkInStatusColumnId: "status", // Check-in Check status
    checkOutDateColumnId: "date_mkynmdew", // Check-out Date
    checkOutStatusColumnId: "color_mkyh2380", // Check-out Check color
    extrasColumnId: "text_mkyf8xv5", // Notes text column (was Extras)
    color: "#a8eb34", // Green
  },
};

